import React, { useState, useEffect } from "react";
import { useTheme } from "next-themes";
import { useAuth0 } from "@auth0/auth0-react";
import AxeCreationTable from "./AxeCreationTable";
import importedAxesStore from "@/store/generateAxeStore";
import { fetchRequestWrapper } from "@/lib/utilities";

const AxeCreationIndex = ({ cryptoID }: { cryptoID: string }) => {
  const { theme } = useTheme();
  const { getAccessTokenSilently } = useAuth0();

  const importAxeData = importedAxesStore((state) => state.allImportedAxes);
  const setImportAxeData = importedAxesStore(
    (state) => state.setAllGeneratedAxes,
  );

  const [readyToRender, setReadyToRender] = useState(false);
  useEffect(() => {
    async function getAxeCreationDBO() {
      const axeDataFromDB = await fetchRequestWrapper(
        { url: "/Axe/Summary" },
        getAccessTokenSilently,
      );
      await setImportAxeData(axeDataFromDB.axes);
      await setReadyToRender(true);
    }
    if (importAxeData.length == 0) {
      try {
        getAxeCreationDBO();
      } catch (error) {
        console.error(error);
      } // eslint-disable-next-line react-hooks/exhaustive-deps
    } else {
      setReadyToRender(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="h-full w-full">
      {readyToRender ? (
        <AxeCreationTable
          cryptoID={cryptoID}
          theme={theme}
          getAccessTokenSilently={getAccessTokenSilently}
          axeCreationData={importAxeData}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default AxeCreationIndex;
